import gql from "graphql-tag";

export const userManagement = gql`
  query userManagement(
    $brokerageId: String!
    $token: String!
    $statuses: [String]!
  ) {
    UserManagement(
      brokerageId: $brokerageId
      token: $token
      statuses: $statuses
    ) {
      su_ID
      su_name
      su_surname
      su_email
      status
      type
    }
  }
`;



// WEBPACK FOOTER //
// ./src/queries/UserManagement.js